let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jg4bP")).then(() => parcelRequire('8DdeG'));